import React from "react";
import Content from "../sections/Forgotpassword/Content";

export const Forgotpassword = (props) => {
  return (
    <div className="ms-body ms-primary-theme ms-logged-out">
      <main className="body-content">
        <Content />
      </main>
    </div>
  );
};

export default Forgotpassword;
